import * as yup from 'yup';

export const TimeosConfigurationSchema = yup.object({
  apiKey: yup.string().required(),
  customer: yup.string().required(),
  username: yup.string().required(),
  password: yup.string().required(),
});

export interface ITimeosConfiguration {
  apiKey: string;
  customer: string;
  username: string;
  password: string;
}
